import { PUBLIC_SWR_KEYS } from "../Utilities/swrKeys";
import { useCachedSWR } from "../Utilities/useCachedSWR";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { isValidUrl } from "../../Shared/components/Navigation/navigationUtils";
import { buildMaps } from "./utils/companyProvider-utils";
import { defaultContextState } from "./utils/companyProviderDefaults";
export const useCompanyConfigQuery = () => {
    var _a, _b;
    const { datadogLog } = useLogging();
    const { data, error, isLoading } = useCachedSWR(PUBLIC_SWR_KEYS.COMPANY_PROVIDER, {
        onSuccess: (data) => {
            if (!data.success) {
                datadogLog("Failed to get CompanyProvider model", LogLevel.ERROR, undefined);
                throw new Error("Something unexpected happened while loading the page. Code: CA1");
            }
        },
        onError: (error) => {
            datadogLog("Failed to get CompanyProvider model", LogLevel.ERROR, undefined, error);
        },
    });
    // If Brand URL is set, use it. Otherwise, use company config website.
    let homeUrl = (data === null || data === void 0 ? void 0 : data.brandUrl) && data.brandUrl.length > 0
        ? data.brandUrl
        : (data === null || data === void 0 ? void 0 : data.website) && data.website.length > 0
            ? data.website
            : "/";
    if (isValidUrl((_a = data === null || data === void 0 ? void 0 : data.brandUrl) !== null && _a !== void 0 ? _a : "")) {
        // Append protocol if not present, assume SSL.
        homeUrl = homeUrl.indexOf("http") === -1 ? `https://${homeUrl}` : homeUrl;
    }
    const { tokenMap, keyMap, companyTextBySectionAndTitle } = buildMaps(data);
    if (!data || isLoading) {
        return Object.assign(Object.assign({}, defaultContextState), { loading: isLoading, error: error === null || error === void 0 ? void 0 : error.message, keyMap, url: homeUrl });
    }
    const displayName = ((_b = data.brandDisplayName) === null || _b === void 0 ? void 0 : _b.length) > 0 ? data.brandDisplayName : data.name;
    return Object.assign(Object.assign({}, data), { myMealsCompanyText: companyTextBySectionAndTitle["MyMealsPage"], orderHistoryCompanyText: companyTextBySectionAndTitle["OrderHistory"], recipeControlCompanyText: companyTextBySectionAndTitle["RecipeControl"], culture: {
            cultureInfo: data.cultureInfo,
            currency: data.currencyType,
            countryCode: data.countryCode,
        }, displayName, url: homeUrl, loading: isLoading, error: error === null || error === void 0 ? void 0 : error.message, keyMap,
        tokenMap });
};
